<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/prAp5Q/media/FC-9781398484849.jpg?1718046581450" alt="This image is the cover for the book Mountain People"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mountain People
      </h1>
      <p class="bookDescription body article font2">
        <p>“You have to love the mountains to live here.” Nevertheless, at seventeen Salva left, returning many years later with Àngels to the family farm. Now it’s a holiday centre. “I was sleeping in the tent. The bear was eating a sheep fifty metres away,” says Mustà, a shepherd who moved to the Pyrenees from Morocco. “Born here… without doctors, without anything.” Josep has never left his mountain village. Once a secretary in Barcelona, his wife María is now the farmer in the family. Five in-depth life stories from the fifteen in Mountain People. Stories of hope in the face of adversity, reflecting our common humanity. Stories that, like the surrounding mountains, will ignite your imagination.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gordon Wilson
      </h2>
      
      <p class="authorDescription body article">Gordon Wilson is emeritusprofessor in Environment and Development. He has previously co-authored Learning for Development, The Lived Experience of Climate Change and Environment, Development and Sustainability, as well as invited chapters for nine further books. He has published The Pyrenees:Trekking the Mountains of Hope and Freedom. Steve Cracknell has written three other books on the Pyrenees. In the first two, the mountains and their inhabitants are seen throughthe eyes of a long-distance walker. His third work, The Implausible Rewilding of the Pyrenees is based on interviews with shepherds, farmers, environmentalists and hunters, some of whom also feature in Mountain People. The author and environmentalist Dr Mark Avery chose it for his Nature Book of the Year, 2021.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7d0396ab